<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("global") }} {{ $t("options") }}
      </div>
    </div>
    <div class="white-wrapper global_option_wrapper">
      <!--START General Settings -->
      <div class="section-wrapper">
        <div class="d-flex">
          <div
            class="sectionName bor d-flex justify-content-between mb-2 col-10 align-item-center"
          >
            <div
              class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="
                collapseObj.generalSettings = !collapseObj.generalSettings
              "
            >
              General Settings
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="collapseObj.generalSettings"
              @click="
                collapseObj.generalSettings = !collapseObj.generalSettings
              "
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="!collapseObj.generalSettings"
              @click="
                collapseObj.generalSettings = !collapseObj.generalSettings
              "
            ></span>
          </div>
          <div class="d-flex col-2 justify-content-center align-items-center">
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mr-3
                    "
                :key="globalListIndex"
                :style="'order:' + getFieldOrder(global.go_key)"
                v-if="global.go_key == 'TEST_SETUP'"
              >
                <b-form-checkbox
                  :id="`${global.go_key}`"
                  v-model="global.go_value"
                  unchecked-value="N"
                  value="Y"
                  :disabled="disableFields(global.go_key)"
                  :class="disableFields(global.go_key) ? 'disable-field' : ''"
                  class="j-checkbox ml-3 mb-3 pb-0"
                >
                  <div
                    class="text-capitalize"
                    v-b-tooltip.hover
                    :title="getToolTipDetails(global.go_key)"
                  >
                    {{ normaliseString(global.go_key) }}
                  </div>
                </b-form-checkbox>
              </div>
            </template>
          </div>
        </div>
        <b-collapse
          v-model="collapseObj.generalSettings"
          class="pt-2 px-2 bor mb-4 back"
        >
          <div class="row py-3">
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="mb-3"
                :class="'col-lg-3 col-md-3'"
                :key="globalListIndex"
                v-if="global.go_key == 'OPERATION_COUNTRY'"
                v-b-tooltip.hover
                :title="getToolTipDetails(global.go_key)"
              >
                <div class="dropdown-curve-container">
                  <label class="shift-up mt-n1"
                    >{{ global.key_name }}
                    <span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                  <multiselect
                    :options="ActiveCountries"
                    v-model="operationCountryObj"
                    @select="OnSelect('country', $event, globalListIndex)"
                    :searchable="true"
                    label="country_name"
                    track-by="country_id"
                    placeholder="Select Country"
                    :allowEmpty="false"
                    :showLabels="false"
                    :multiple="false"
                  ></multiselect>
                </div>
              </div>
              <div
                class="mb-3"
                :class="'col-lg-3 col-md-3'"
                :key="globalListIndex"
                v-if="global.go_key == 'CURRENCY'"
                v-b-tooltip.hover
                :title="getToolTipDetails(global.go_key)"
              >
                <div class="dropdown-curve-container">
                  <label class="shift-up mt-n1"
                    >{{ global.key_name
                    }}<span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                  <multiselect
                    :options="ActiveCurrencies"
                    v-model="activeCurrencyObj"
                    @select="OnSelect('currency', $event, globalListIndex)"
                    :searchable="true"
                    label="curr_name"
                    track-by="curr_id"
                    placeholder="Select Currency"
                    :allowEmpty="false"
                    :showLabels="false"
                    :multiple="false"
                  ></multiselect>
                </div>
              </div>
              <div
                class="mb-3"
                :class="'col-lg-3 col-md-3'"
                :key="globalListIndex"
                v-if="global.go_key == 'START_DAY'"
              >
                <div
                  class="dropdown-curve-container"
                  v-b-tooltip.hover
                  :title="getToolTipDetails(global.go_key)"
                >
                  <label class="shift-up mt-n1"
                    >{{ global.key_name
                    }}<span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                  <multiselect
                    :options="Days"
                    v-model="selected_day"
                    label="day"
                    track-by="id"
                    placeholder="Select Start Day"
                    :allowEmpty="false"
                    :showLabels="false"
                    :multiple="false"
                    @select="onSelectDay($event)"
                  />
                </div>
              </div>
              <div
                style=""
                class="col-lg-3 col-md-3 mb-2"
                :key="globalListIndex"
                v-if="
                  global.go_key == 'MIN_FRACTION_DIGITS' ||
                    global.go_key == 'TIME_ZONE' ||
                    global.go_key == 'CLIENT_SETUP_NAME' ||
                    global.go_key == 'POS_URL' ||
                    global.go_key == 'MACCS_LOGS_HISTORY'
                "
                :style="'order:' + getFieldOrder(global.go_key)"
              >
                <div
                  class="input-material"
                  v-b-tooltip.hover
                  :title="getToolTipDetails(global.go_key)"
                  :style="'order:' + getFieldOrder(global.go_key)"
                >
                  <input
                    :style="
                      global.go_key == 'POS_LOCK_SCREEN_TIME' ||
                      global.go_key == 'POS_FINAL_PAGE_STANDBY_TIME_IN_MINS' ||
                      global.go_key == 'POS_SEAT_EXTEND_ALERT_IN_SEC' ||
                      global.go_key == 'MACCS_LOGS_HISTORY' ||
                      global.go_key == 'MIN_FRACTION_DIGITS'
                        ? 'text-align:right;'
                        : 'text-align:left;'
                    "
                    v-model="global.go_value"
                    v-validate="'required'"
                    placeholder="."
                    :disabled="disableFields(global.go_key)"
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label
                    >{{ getKeyName(global)
                    }}<span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                </div>
                <p
                  v-if="submitted && errors.has('subject')"
                  class="error_message"
                >
                  <span>{{ errors.first("subject") }}</span>
                </p>
              </div>
            </template>
          </div>
          <div class="row pt-3 d-none">
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mr-3
                    "
                :key="globalListIndex"
                :style="'order:' + getFieldOrder(global.go_key)"
                v-if="
                  global.go_key == 'ENABLE_COVID_SEAT_LAYOUT' ||
                    global.go_key == 'TEST_SETUP' ||
                    global.go_key == 'SCHEDULE_AUTO_SAVE' ||
                    global.go_key == 'USE_RATECARD_ADDONS' ||
                    global.go_key == 'ENTRY_ID_REQUIRED_QRAPP'
                "
              >
                <b-form-checkbox
                  :id="`${global.go_key}`"
                  v-model="global.go_value"
                  unchecked-value="N"
                  value="Y"
                  :disabled="disableFields(global.go_key)"
                  :class="disableFields(global.go_key) ? 'disable-field' : ''"
                  class="j-checkbox ml-3 mb-3"
                >
                  <div
                    class="text-capitalize"
                    v-b-tooltip.hover
                    :title="getToolTipDetails(global.go_key)"
                  >
                    {{ normaliseString(global.go_key) }}
                  </div>
                </b-form-checkbox>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <!--END General Settings -->

      <!--START url -->
      <div class="section-wrapper">
        <div
          class="sectionName bor d-flex justify-content-between mb-2 align-item-center"
        >
          <div
            class="fs-17 font-weight-bold pl-2 align-items-center"
            @click="collapseObj.urlSettings = !collapseObj.urlSettings"
          >
            URL
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.urlSettings"
            @click="collapseObj.urlSettings = !collapseObj.urlSettings"
          ></span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.urlSettings"
            @click="collapseObj.urlSettings = !collapseObj.urlSettings"
          ></span>
        </div>
        <b-collapse
          v-model="collapseObj.urlSettings"
          class="pt-2 px-2 bor mb-4 back"
        >
          <div class="row py-3">
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="col-lg-4 col-md-4 mb-2"
                :key="globalListIndex"
                v-if="
                  global.go_key == 'DASHBOARD_URL' ||
                    global.go_key == 'SCANNING_APP_URL' ||
                    global.go_key == 'TMS_URL'
                "
                :style="'order:' + getFieldOrder(global.go_key)"
              >
                <div
                  class="input-material"
                  v-b-tooltip.hover
                  :title="getToolTipDetails(global.go_key)"
                  :style="'order:' + getFieldOrder(global.go_key)"
                >
                  <input
                    :style="
                      global.go_key == 'POS_LOCK_SCREEN_TIME' ||
                      global.go_key == 'POS_FINAL_PAGE_STANDBY_TIME_IN_MINS' ||
                      global.go_key == 'POS_SEAT_EXTEND_ALERT_IN_SEC' ||
                      global.go_key == 'MACCS_LOGS_HISTORY' ||
                      global.go_key == 'MIN_FRACTION_DIGITS'
                        ? 'text-align:right;'
                        : 'text-align:left;'
                    "
                    v-model="global.go_value"
                    v-validate="'required'"
                    placeholder="."
                    :disabled="disableFields(global.go_key)"
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label
                    >{{ getKeyName(global)
                    }}<span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                </div>
                <p
                  v-if="submitted && errors.has('subject')"
                  class="error_message"
                >
                  <span>{{ errors.first("subject") }}</span>
                </p>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <!--END url -->

      <!--START Schedule -->
      <div class="section-wrapper">
        <div
          class="sectionName bor d-flex justify-content-between mb-2 align-item-center"
        >
          <div
            class="fs-17 font-weight-bold pl-2 align-items-center"
            @click="collapseObj.scheduleSetting = !collapseObj.scheduleSetting"
          >
            Schedule
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.scheduleSetting"
            @click="collapseObj.scheduleSetting = !collapseObj.scheduleSetting"
          ></span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.scheduleSetting"
            @click="collapseObj.scheduleSetting = !collapseObj.scheduleSetting"
          ></span>
        </div>
        <b-collapse
          v-model="collapseObj.scheduleSetting"
          class="pt-2 px-2 bor mb-4 back"
        >
          <div class="row py-3">
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mr-3
                    "
                :key="globalListIndex"
                :style="'order:' + getFieldOrder(global.go_key)"
                v-if="
                  global.go_key == 'ENABLE_COVID_SEAT_LAYOUT' ||
                    global.go_key == 'SCHEDULE_AUTO_SAVE' ||
                    global.go_key == 'USE_RATECARD_ADDONS' || 
                    global.go_key == 'ENTRY_ID_REQUIRED_QRAPP'
                "
              >
                <b-form-checkbox
                  :id="`${global.go_key}`"
                  v-model="global.go_value"
                  unchecked-value="N"
                  value="Y"
                  :disabled="disableFields(global.go_key)"
                  :class="disableFields(global.go_key) ? 'disable-field' : ''"
                  class="j-checkbox ml-3 mb-3"
                >
                  <div
                    class="text-capitalize"
                    v-b-tooltip.hover
                    :title="getToolTipDetails(global.go_key)"
                  >
                    {{ getKeyName(global) }}
                  </div>
                </b-form-checkbox>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <!--END Schedule -->

      <!--START Language Settings -->
      <div class="section-wrapper">
        <div
          class="sectionName bor d-flex justify-content-between mb-2 align-item-center"
        >
          <div
            class="fs-17 font-weight-bold pl-2 align-items-center"
            @click="
              collapseObj.languageSettings = !collapseObj.languageSettings
            "
          >
            Langauge Settings
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.languageSettings"
            @click="
              collapseObj.languageSettings = !collapseObj.languageSettings
            "
          ></span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.languageSettings"
            @click="
              collapseObj.languageSettings = !collapseObj.languageSettings
            "
          ></span>
        </div>
        <b-collapse
          v-model="collapseObj.languageSettings"
          class="pt-2 px-2 mb-4 bor back"
        >
          <div
            class="row py-3 justify-content-end"
            style="flex-direction:row-reverse;"
          >
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="mb-3"
                :class="'col-lg-4 col-md-4'"
                :key="globalListIndex"
                v-if="global.go_key == 'DEFAULT_COMMUNICATION_LANGUAGE'"
              >
                <div
                  class="dropdown-curve-container"
                  v-b-tooltip.hover
                  :title="getToolTipDetails(global.go_key)"
                >
                  <label class="shift-up mt-n1"
                    >{{ global.key_name }}
                    <span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                  <multiselect
                    :options="ActiveLanguages"
                    v-model="defaultUserLanguage"
                    :searchable="true"
                    label="lang_name"
                    track-by="lang_id"
                    placeholder="Select Languages"
                    :allowEmpty="false"
                    :showLabels="false"
                    :multiple="false"
                  />
                </div>
              </div>

              <div
                class="mb-2"
                :class="'col-6'"
                :key="globalListIndex"
                v-if="global.go_key == 'CONTENT_LANGUAGE'"
              >
                <div
                  class="dropdown-curve-container"
                  v-b-tooltip.hover
                  :title="getToolTipDetails(global.go_key)"
                >
                  <label class="shift-up mt-n1"
                    >Content Languages
                    <span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                  <multiselect
                    :options="ActiveLanguages"
                    v-model="content_language"
                    @select="onSelectContentLanguages($event)"
                    @remove="onSelectContentLanguages($event)"
                    :searchable="true"
                    label="lang_name"
                    track-by="lang_id"
                    placeholder="Select Language"
                    :allowEmpty="false"
                    :showLabels="false"
                    :multiple="true"
                  ></multiselect>
                </div>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <!--END Language Settings -->

      <!--START Communication Settings Emails and other emails settings -->
      <div class="section-wrapper">
        <div
          class="sectionName bor d-flex justify-content-between mb-2 align-item-center"
        >
          <div
            class="fs-17 font-weight-bold pl-2 align-items-center"
            @click="
              collapseObj.communicationSettings = !collapseObj.communicationSettings
            "
          >
            Communication Settings &nbsp;&nbsp;<span
              class="text-red fs-12 text-small-instruction align-items-center"
              >Use comma seperated Values for Multiple Emails</span
            >
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.communicationSettings"
            @click="
              collapseObj.communicationSettings = !collapseObj.communicationSettings
            "
          ></span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.communicationSettings"
            @click="
              collapseObj.communicationSettings = !collapseObj.communicationSettings
            "
          ></span>
        </div>
        <b-collapse
          v-model="collapseObj.communicationSettings"
          class="pt-2 px-2 bor mb-4 back"
        >
          <div class="row py-3">
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="col-lg-4 col-md-4 mb-2"
                :style="'order:' + getFieldOrder(global.go_key)"
                :key="globalListIndex"
                v-if="
                  global.go_key == 'DEFAULT_COMMUNICATION_EMAIL' ||
                    global.go_key == 'SUPPORT_EMAIL' ||
                    global.go_key == 'CONTACT_FORM_EMAIL_TO' ||
                    global.go_key == 'CONTACT_FORM_EMAIL_CC' ||
                    global.go_key == 'EMAIL_BCC' ||
                    global.go_key == 'ERROR_EMAIL_RECIPIENTS' ||
                    global.go_key == 'SENDER_EMAIL'
                "
              >
                <div class="d-flex align-items-center">
                  <div
                    v-if="global.go_key == 'SUPPORT_EMAIL'"
                    class="input-material"
                  >
                    <input
                      v-model="global.go_value"
                      name="subject"
                      id="subject"
                    />
                    <label
                      >{{ normaliseString(global.go_key)
                      }}<span
                        v-if="checkCompursory(global.go_key)"
                        class="compulsory_astrick"
                        >*</span
                      ></label
                    >
                  </div>

                  <div
                    class="input-material-textarea"
                    v-if="global.go_key !== 'SUPPORT_EMAIL'"
                  >
                    <textarea
                      placeholder="."
                      rows="3"
                      type="text"
                      v-model="global.go_value"
                      name="subject"
                      id="subject"
                      style="
                        border-radius: 10px;
                        border-color: #d3d3d3;
                        overflow-y: auto;
                      "
                    />
                    <label
                      >{{ normaliseString(global.go_key)
                      }}<span
                        v-if="checkCompursory(global.go_key)"
                        class="compulsory_astrick"
                        >*</span
                      ></label
                    >
                  </div>
                  <Tooltip :title="getToolTipDetails(global.go_key)" />
                </div>
                <!-- <div class="input-material">
                  <input
                    v-model="global.go_value"
                    v-validate="'required'"
                    placeholder="."
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label v-if="global.go_id != 14"></label>
                </div> -->
                <p
                  v-if="submitted && errors.has('subject')"
                  class="error_message"
                >
                  <span>{{ errors.first("subject") }}</span>
                </p>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <!--END  Communication Settings Emails and other emails settings -->

      <!--START POS/FNB Settings -->
      <div class="section-wrapper">
        <div
          class="sectionName bor d-flex justify-content-between mb-2 align-item-center"
        >
          <div
            class="fs-17 font-weight-bold pl-2 align-items-center"
            @click="collapseObj.posfnbsettings = !collapseObj.posfnbsettings"
          >
            POS/FNB Settings
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.posfnbsettings"
            @click="collapseObj.posfnbsettings = !collapseObj.posfnbsettings"
          ></span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.posfnbsettings"
            @click="collapseObj.posfnbsettings = !collapseObj.posfnbsettings"
          ></span>
        </div>
        <b-collapse
          v-model="collapseObj.posfnbsettings"
          class="pt-2 px-2 bor mb-4 back"
        >
          <div class="row py-3">
            <template v-for="(global, globalListIndex) in globalList">
              <div
                class="
                 col-4
                 mb-2
                "
                :key="globalListIndex"
                :style="'order:' + getFieldOrder(global.go_key)"
                v-if="
                  global.go_key == 'POS_LOCK_SCREEN_TIME' ||
                    global.go_key == 'POS_FINAL_PAGE_STANDBY_TIME_IN_MINS' ||
                    global.go_key == 'POS_SEAT_EXTEND_ALERT_IN_SEC'
                "
              >
                <div
                  class="input-material"
                  v-b-tooltip.hover
                  :title="getToolTipDetails(global.go_key)"
                  :style="'order:' + getFieldOrder(global.go_key)"
                >
                  <input
                    v-model="global.go_value"
                    v-validate="'required'"
                    placeholder="."
                    :disabled="disableFields(global.go_key)"
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label
                    >{{ getKeyName(global)
                    }}<span
                      v-if="checkCompursory(global.go_key)"
                      class="compulsory_astrick"
                      >*</span
                    ></label
                  >
                </div>
              </div>

              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  checkboxWrapper
                "
                :style="'order:' + getFieldOrder(global.go_key)"
                :key="globalListIndex"
                v-if="
                  global.go_key == 'STOCK_DEDUCTION' ||
                    global.go_key == 'NEGATIVE_STOCK_DEDUCTION' ||
                    global.go_key == 'POS_CUSTOMER_POPUP' ||
                    global.go_key == 'SHOW_POS_SEND_SMS_SECTION' ||
                    global.go_key == 'POS_DIRECT_PRINT' ||
                    global.go_key == 'POS_INPUT_CASH_VALIDATION' ||
                    global.go_key == 'SHOW_PRINT_RECEIPT_BTN_POS' ||
                    global.go_key == 'SHOW_VEG_NONVEG_lOGO'
                "
              >
                <b-form-checkbox
                  :id="`${global.go_key}`"
                  v-model="global.go_value"
                  unchecked-value="N"
                  value="Y"
                  class="j-checkbox mx-3 mb-3"
                >
                  <div
                    class="text-capitalize"
                    v-b-tooltip.hover
                    :title="getToolTipDetails(global.go_key)"
                  >
                    {{ getKeyName(global) }}
                  </div>
                </b-form-checkbox>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <!--END POS/FNB Settings -->

      <div class="col-md-12 py-4 border-top text-center">
        <button
          :disabled="btenable"
          @click.prevent.stop="onFinalSubmit()"
          class="btn-blue"
        >
          {{ $t("update") }}</button
        >&nbsp;
        <button
          :disabled="btenable"
          @click.prevent.stop="gotoHome()"
          class="btn-blue"
        >
          {{ $t("cancel") }}</button
        >&nbsp;
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import MasterService from "@/services/MasterService";
import _ from "lodash";

export default {
  data() {
    return {
      collapseObj: {
        communicationSettings: true,
        urlSettings: true,
        scheduleSetting: true,
        languageSettings: true,
        posfnbsettings: true,
        generalSettings: true
      },
      btenable: false,
      globalList: [],
      submitted: false,
      ActiveCountries: [],
      selectedCountry: "",
      operation_country: "",
      operationCountryObj: "",
      ActiveLanguages: [],
      content_language: [],
      content_country: {},
      app_language: "",
      ActiveCurrencies: [],
      currency_name: "",
      activeCurrencyObj: "",
      ActiveConcessions: [],
      Cinemas: [],
      concession_name: "",
      globalListCopy: [],
      selectedCinema: null,
      selectedLanguages: null,
      defaultUserLanguage: null,
      kioks_temp_language_array: [],
      Days: [
        { id: 1, day: "Monday" },
        { id: 2, day: "Tuesday" },
        { id: 3, day: "Wednesday" },
        { id: 4, day: "Thursday" },
        { id: 5, day: "Friday" },
        { id: 6, day: "Saturday" },
        { id: 7, day: "Sunday" }
      ],
      selected_day: "",
      start_day: ""
    };
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;

    if (roleid != 1) {
      this.$router.go(-1);
    } else {
      this.getGlobalOptions();
    }
  },
  methods: {
    getFieldOrder(key) {
      let order = 0;
      // According to this orderArray fields will get SORTED/ORDER in the PAGE AUTOMATICALLY BY the index number
      let orderArray = [
        "OPERATION_COUNTRY",
        "CURRENCY",
        "START_DAY",
        "TIME_ZONE",

        "MIN_FRACTION_DIGITS",
        "CLIENT_SETUP_NAME",
        "POS_URL",
        "DASHBOARD_URL",
        "SCANNING_APP_URL",
        "TMS_URL",
        "TEST_SETUP",
        "24_HRS_FORMAT",
        "SCHEDULE_AUTO_SAVE",
        "MYCINEMA_STATUS",
        "ENABLE_COVID_SEAT_LAYOUT",
        "USE_RATECARD_ADDONS",
        "SENDER_EMAIL",
        "EMAIL_BCC",
        "CONTACT_FORM_EMAIL_TO",
        "ERROR_EMAIL_RECIPIENTS",
        "CONTACT_FORM_EMAIL_CC",
        "DEFAULT_COMMUNICATION_EMAIL",
        "SUPPORT_EMAIL",
        "POS_LOCK_SCREEN_TIME",
        "POS_FINAL_PAGE_STANDBY_TIME_IN_MINS",
        "POS_SEAT_EXTEND_ALERT_IN_SEC",
        "STOCK_DEDUCTION",
        "NEGATIVE_STOCK_DEDUCTION",
        "POS_CUSTOMER_POPUP",
        "SHOW_POS_SEND_SMS_SECTION",
        "POS_DIRECT_PRINT",
        "POS_INPUT_CASH_VALIDATION",
        "SHOW_PRINT_RECEIPT_BTN_POS"
      ];
      order = orderArray.findIndex(arKey => arKey == key);
      console.log("ORDER", order, key);
      if (order > -1) {
        return order;
      } else {
        return 10000;
      }
    },
    checkCompursory(key) {
      let checkArray = [
        "OPERATION_COUNTRY",
        "CURRENCY",
        "TIME_ZONE",
        "CONTENT_LANGUAGE",
        "SENDER_EMAIL"
      ];
      if (checkArray.includes(key)) {
        return true;
      } else {
        return false;
      }
    },
    getKeyName(global) {
      if (global.go_key == "POS_FINAL_PAGE_STANDBY_TIME_IN_MINS") {
        return `POS standby (mins)`;
      } else if (global.go_key == "POS_LOCK_SCREEN_TIME") {
        return `POS Lock Screen (mins)`;
      } else if (global.go_key == "POS_SEAT_EXTEND_ALERT_IN_SEC") {
        return `POS Seat ext. alert (secs)`;
      } else if (global.go_key == "SHOW_POS_SEND_SMS_SECTION") {
        return `POS SMS Section`;
      } else if (global.go_key == "MACCS_LOGS_HISTORY") {
        return `Clear Maccs Logs (Days)`;
      } else if(global.go_key == "ENTRY_ID_REQUIRED_QRAPP") {
        return `Entry ID Required`;
      } else if(global.go_key == "SHOW_VEG_NONVEG_lOGO") {
        return `Show veg/non-veg Mark`;
      }else {
        return this.normaliseString(global.go_key);
      }
    },
    disableFields(key) {
      let keyArr = ["VIP_SEAT_RELEASE_TIMEOUT", "24_HRS_FORMAT"];
      if (keyArr.includes(key)) {
        return true;
      } else {
        return false;
      }
    },
    normaliseString(str) {
      let text = str;
      if (str) {
        text = str.replaceAll("_", " ");
        text = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        text = text.replaceAll(/Pos/gi, "POS");
      }
      return text;
    },
    getToolTipDetails(key) {
      let text = ``;
      if (key == "CONTACT_FORM_EMAIL_TO") {
        text = `Enquiry/Contact US Recepients Email Addresses`;
      } else if (key == "SUPPORT_EMAIL") {
        text = `Support Email in Email templates`;
      } else if (key == "CONTACT_FORM_EMAIL_CC") {
        text = `Enquiry/Contact US CC Email Addresses`;
      } else if (key == "SENDER_EMAIL") {
        text = `SENDER OF ALL EMAILS (From)`;
      } else if (key == "SENDER_EMAIL") {
        text = `SENDER (From) OF ALL EMAILS, All emails will be sent from this email Address`;
      } else if (key == "ERROR_EMAIL_RECIPIENTS") {
        text = `If any error comes in the functinality Eg: SMS not sent to customer will be notify on this email`;
      } else if (key == "DEFAULT_COMMUNICATION_EMAIL") {
        text = `Emails related to Show Overview will be received on this email`;
      } else if (key == "EMAIL_BCC") {
        text = `Add BCC emails to all ticket emails if show is confirmed`;
      } else if (key == "POS_INPUT_CASH_VALIDATION") {
        text = `Allow Booking without entering amount in POS`;
      } else if (key == "SHOW_PRINT_RECEIPT_BTN_POS") {
        text = `Hide Print Receipt button from POS final ticket Page`;
      } else if (key == "POS_DIRECT_PRINT") {
        text = `Direclty Print ticket after booking in POS`;
      } else if (key == "POS_DIRECT_PRINT") {
        text = `Direclty Print ticket after booking in POS`;
      } else if (key == "SHOW_POS_SEND_SMS_SECTION") {
        text = `Enable/Disable SMS section in POS Final Ticket Page`;
      } else if (key == "POS_CUSTOMER_POPUP") {
        text = `Automatically POPUP Add customer Details on Payment Page`;
      } else if (key == "ENABLE_FNB") {
        text = `Enable FNB`;
      } else if (key == "ENABLE_COVID_SEAT_LAYOUT") {
        text = `Block Alternative Seats as per Covid Restrictions`;
      } else if (key == "MYCINEMA_STATUS") {
        text = `Enable/Disable Mycinema`;
      } else if (key == "TEST_SETUP") {
        text = `IS TEST SETUP`;
      } else if (key == "SCHEDULE_AUTO_SAVE") {
        text = `Auto Save Schedule on drag`;
      } else if (key == "USE_RATECARD_ADDONS") {
        text = `Enable Ratecard Addons Feature`;
      } else if (key == "CONTENT_LANGUAGE") {
        text = `Avaliable Content Languages all over the Application`;
      } else if (key == "DEFAULT_COMMUNICATION_LANGUAGE") {
        text = `Default Language for Emails and Tickets`;
      } else if (key == "START_DAY") {
        text = `Start Day of the Week `;
      } else if (key == "MIN_FRACTION_DIGITS") {
        text = `Digits After decimals eg: min fraction digit is 2 then number will look like 5.00`;
      } else if (key == "POS_FINAL_PAGE_STANDBY_TIME_IN_MINS") {
        text = `Redirect to Home Page when idle`;
      } else if (key == "POS_SEAT_EXTEND_ALERT_IN_SEC") {
        text = `Time before seat release to show popup to extend time`;
      } else if (key == "CLIENT_SETUP_NAME") {
        text = `Setup name to filter ticket templates`;
      } else if (key == "TIME_FORMAT") {
        text = `Time format all over Application`;
      } else if (key == "STOCK_DEDUCTION") {
        text = `Deduction of stock from store when item sold`;
      } else if (key == "NEGATIVE_STOCK_DEDUCTION") {
        text = `Allow Selling of items even if stock is negative`;
      } else if (key == "24_HRS_FORMAT") {
        text = `Time format all over Application`;
      } else if (key == "OPERATION_COUNTRY") {
        text = `Default Country`;
      } else if (key == "CURRENCY") {
        text = `Default Currency all over application`;
      } else if (key == "TIME_ZONE") {
        text = `Default Time Zone`;
      } else if (key == "POS_LOCK_SCREEN_TIME") {
        text = `POS Lock Screen Time`;
      } else if (key == "TMS_URL") {
        text = `TMS url`;
      } else if (key == "SCANNING_APP_URL") {
        text = `Qrcode app URL`;
      } else if (key == "POS_URL") {
        text = `POS URL`;
      } else if (key == "DASHBOARD_URL") {
        text = `Dashboard URL`;
      } else if (key == "MACCS_LOGS_HISTORY") {
        text = `Clear Maccs Logs (Days)`;
      } else if(key == "ENTRY_ID_REQUIRED_QRAPP") {
        text = `Entry ID required in qrcode App`;
      } else if(key == "SHOW_VEG_NONVEG_lOGO") {
        text = `Show Veg/NonVeg Mark on Food items`;
      } else {
        text = this.normaliseString(key);
      }
      return text;
    },
    onToggleMoreSettings(collapse) {
      collapse = !collapse;
    },
    onSelectContentLanguages(event) {
      this.selectedLanguages = _.cloneDeep(this.content_language);
      console.log("Event onSelectContentLanguages", event);
    },
    onSelectCinema(cinema) {
      this.selectedCinema = cinema.cine_name;
      this.$forceUpdate();
    },
    onSelectDay(Day) {
      this.selected_day = Day;
      this.start_day = Day.day;
    },
    getGlobalOptions: function() {
      let loader = this.$loading.show();
      let payload = {
        globalOptionsPrivate: "Y"
      };
      MasterService.GetGlobalOptions(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.globalList = data.Records.filter(x => {
            //   return (
            //     x.go_id != 2 && x.go_id != 12 && x.go_id != 14 && x.go_id != 19
            //   );
            // });
            this.globalList = data.Records;
            // const arr_copy = [...data.Records]
            this.globalListCopy = JSON.parse(JSON.stringify(this.globalList));
            this.globalList.map(x => {
              x.key_name = this.normaliseString(x.key_name);
              if (x.go_id == 9) {
                this.getActiveCountries(x.go_value, 2);
              }
              if (x.go_key == "CONTENT_LANGUAGE") {
                let obj = JSON.parse(x.go_value);
                console.log("obj :>> ", obj);
                this.getActiveCountries(obj[0].country_id, 1);
                this.getActiveLanguages(obj[0].lang_id, 1);
              }
              if (x.go_id == 8) {
                this.getActiveLanguages(x.go_value, 2);
              }
              if (x.go_id == 10) {
                this.getActiveCurrencies(x.go_value);
              }
              if (x.go_id == 11) {
                this.getActiveConcessions(x.go_value);
              }
              // if (x.go_id == 31) {
              //   this.getCinemaList();
              //   this.selectedCinema = JSON.parse(x.go_value);
              // }
              if (x.go_key == "KIOSK_LANGUAGE") {
                let kioskLanguages = JSON.parse(x.go_value) || [];
                this.kioks_temp_language_array =
                  kioskLanguages.length > 0
                    ? kioskLanguages.map(x => x.lang_id)
                    : [];
              }

              if (x.go_key == "START_DAY") {
                this.selected_day = this.Days.filter(y => {
                  return y.day == x.go_value;
                });
              }

              if (x.go_key === "DEFAULT_COMMUNICATION_LANGUAGE") {
                try {
                  let obj = JSON.parse(x.go_value);
                  this.defaultUserLanguage = {
                    lang_id: obj.lang_id,
                    lang_name: obj.lang_name
                  };
                } catch (err) {
                  console.log(err);
                }
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    // async getCinemaList(cine_id) {
    //   try {
    //     const { data } = await MasterService.GetCinemas({ cine_id });
    //     if (data && data.status && data.Records.length > 0) {
    //       this.Cinemas = data.Records;
    //       this.Cinemas.map(x => {
    //         if (String(cine_id) === String(x.cine_id)) {
    //           // this.selectedCinema = x.cine_name;
    //           this.onSelectCinema(null, {
    //             cine_name: x.cine_name,
    //             cine_id: x.cine_id
    //           });
    //         }
    //       });
    //     } else {
    //       this.$toasted.show(
    //         data.message ||
    //           "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     }
    //   } catch (error) {
    //     this._CatchError;
    //   }
    // },
    getActiveCurrencies(curr_id) {
      let body = {
        tableName: "ms_currencies",
        curr_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveCurrencies = data.Records;
              this.ActiveCurrencies.map(x => {
                if (String(curr_id) === String(x.curr_id)) {
                  this.currency_name = x.curr_name;
                  this.activeCurrencyObj = x;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveConcessions(cl_id) {
      let body = {
        tableName: "ms_concession_levels",
        cl_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveConcessions = data.Records;
              this.ActiveConcessions.map(x => {
                if (String(cl_id) === String(x.cl_id)) {
                  this.concession_name = x.cl_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveCountries(country_id, flag) {
      let body = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveCountries = data.Records;
              console.log("this.ActiveCountries :>> ", this.ActiveCountries);
              this.ActiveCountries.map(x => {
                if (String(country_id) === String(x.country_id) && flag == 2) {
                  this.operation_country = x.country_name;
                  this.operationCountryObj = x;
                  this.content_country = x;
                } else if (
                  String(country_id) === String(x.country_id) &&
                  flag == 1
                ) {
                  this.content_country = x;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveLanguages(lang_id, flag) {
      let body = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              // this.ActiveLanguages = data.Records;
              this.ActiveLanguages = _.sortBy(data.Records, "order");
              if (this.kioks_temp_language_array.length > 0) {
                this.selectedLanguages = this.ActiveLanguages.filter(item =>
                  this.kioks_temp_language_array.includes(item.lang_id)
                );
                this.selectedLanguages = _.sortBy(
                  this.selectedLanguages,
                  "order"
                );
              }
              console.log("this.ActiveLanguages :>> ", this.ActiveLanguages);
              this.ActiveLanguages.map(x => {
                if (flag == 1) {
                  lang_id.map(y => {
                    if (String(y) === String(x.lang_id)) {
                      this.content_language.push(x);
                    }
                  });
                } else if (String(lang_id) === String(x.lang_id) && flag == 2) {
                  this.app_language = x.lang_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    gotoHome() {
      this.$router.push({
        path: "/home"
      });
    },
    checkValid() {
      let count = 0;
      let errorMsg = ``;
      this.globalList.map(x => {
        if (!this.operation_country || !this.content_country.country_id) {
          count++;
          errorMsg = `Please Select Operation Country`;
        } else if (this.content_language.length == 0) {
          count++;
          errorMsg = `Please Select Atleast One Content Language`;
        } else if (x.go_key == "CURRENCY" && !x.go_value) {
          count++;
          errorMsg = `Please Select Currency`;
        } else if (x.go_key == "TIME_ZONE" && !x.go_value) {
          count++;
          errorMsg = `Please Select Time Zone`;
        } else if (x.go_key == "SENDER_EMAIL" && !x.go_value) {
          count++;
          errorMsg = `Please Select Sender Email`;
        }
      });

      if (count > 0) {
        this.$toasted.show(errorMsg);
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function() {
      let finalObj = [];
      if (this.checkValid()) {
        return false;
      } else {
        this.content_language = _.sortBy(this.content_language, "order");
        this.selectedLanguages = _.sortBy(this.content_language, "order");
        let arr = [
          {
            country_id: this.content_country.country_id,
            lang_id: this.content_language.map(x => {
              return x.lang_id;
            })
          }
        ];
        let arr2 = JSON.stringify(arr);
        console.log("arr2 :>> ", arr2);
        this.globalList.map(x => {
          if (x.go_key == "CONTENT_LANGUAGE") {
            x.go_value = arr2;
          }
          // if (x.go_id == 31) {
          //   x.go_value = JSON.stringify(this.selectedCinema);
          // }
          if (x.go_key == "KIOSK_LANGUAGE") {
            this.selectedLanguages = _.sortBy(this.selectedLanguages, "order");
            x.go_value = JSON.stringify(this.selectedLanguages);
          }

          if (x.go_key == "DEFAULT_COMMUNICATION_LANGUAGE") {
            x.go_value = this.defaultUserLanguage
              ? JSON.stringify({
                  lang_id: this.defaultUserLanguage.lang_id,
                  lang_name: this.defaultUserLanguage.lang_name
                })
              : "";
          }
          if (x.go_key == "START_DAY") {
            x.go_value = this.start_day ? this.start_day : "Monday";
          }
        });
        console.log("this.globalList :>> ", this.globalList);
        this.globalList.map((x, i) => {
          // console.log('x.go_value :>> ', x.go_value);
          // console.log('this.globalListCopy[i].go_value :>> ',this.globalListCopy[i].go_value);
          if (x.go_value != this.globalListCopy[i].go_value) {
            finalObj.push(x);
          }
        });
        console.log("finalObj :>> ", finalObj);

        let payload = {
          globalList: finalObj
        };
        MasterService.EditGlobalOptions(payload)
          .then(response => {
            const { data } = response;
            // loader.hide();
            if (data && data.status) {
              this.$toasted.show(data.message);
              this.$store.dispatch("fetchGlobalOptions");
              this.$router.push({
                path: "/home"
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
      }
    },
    OnSelect(type, item, index) {
      if (type == "country" && this.globalList[index].go_id == 9) {
        this.operation_country = item.country_name;
        this.operationCountryObj = item;
        this.globalList[index].go_value = item.country_id;
        this.content_country = item;
        console.log(
          "this.globalList[index].go_value :>> ",
          this.globalList[index].go_value
        );
      } else if (type == "country" && this.globalList[index].go_id == 7) {
        this.content_country = item;
      } else if (type == "lang") {
        this.app_language = item.lang_name;
        this.globalList[index].go_value = item.lang_id;
      } else if (type == "concession") {
        this.concession_name = item.cl_name;
        this.globalList[index].go_value = item.cl_id;
        console.log("concession :>> ", this.globalList[index].go_value);
      } else if (type == "currency") {
        this.currency_name = item.curr_name;
        this.activeCurrencyObj = item;
        this.globalList[index].go_value = item.curr_id;
      }
    }
  }
};
</script>

<style>
.global_option_wrapper label:not(.custom-control-label) {
  font-size: 11px !important;
  font-weight: 600;
  color: black;
}

.compulsory_astrick {
  top: -5px;
  right: -4px;
  font-size: 19px;
  position: absolute;
  color: red;
}

.checkboxWrapper {
  width: 250px;
  font-size: 13px;
}

.global_option_wrapper .multiselect__single {
  font-size: 13px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.global_option_wrapper .multiselect__content-wrapper {
  width: auto;
}
.sectionName {
  padding: 5px 0px;
  color: #4a87e1;
}
.sectionName .fs-17 {
  font-size: 17px !important;
}
.text-small-instruction {
  font-weight: 400;
}
.text-red {
  color: red;
}

.disable-field {
  cursor: not-allowed;
  opacity: 0.5;
}
.bor {
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}
.back {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GlobalOptionsComponents/globalOptionsV2.vue